import { action, makeObservable, observable } from 'mobx';
import { gameStore } from './gameStore';

class AutoBetStore {
  isPlay = false;

  autoBetCount = 0;

  constructor() {
    makeObservable(this, {
      isPlay: observable,
      autoBetCount: observable,
      resetAutoBet: action.bound,
      setIsPlay: action.bound,
      setAutoBetCount: action.bound,
      decrementAutoBetCount: action.bound,
    });
  }

  resetAutoBet() {
    this.isPlay = false;
    this.autoBetCount = 0;
    gameStore.setIsBetsClosed(false);
  }

  setAutoBetCount(count) {
    this.autoBetCount = count;
  }

  setIsPlay() {
    this.isPlay = !this.isPlay;
  }

  decrementAutoBetCount() {
    this.autoBetCount -= 1;
  }
}

export const autoBetStore = new AutoBetStore();
